import {
  TournamentsDefaultsClient,
  PlayPracticeGameDto,
  PracticeGameEntry,
} from "@nestcoinco/hyper-api-gateway-api-client";

import apiConfig, { platformType } from "../config/api-config";
import { axiosInstance } from "../config/axios-instance";

const tournamentsDefaultClient = new TournamentsDefaultsClient(
  apiConfig,
  undefined,
  axiosInstance
);

export const handlePlayPracticeGame = async (
  playPracticeDto?: PlayPracticeGameDto
): Promise<PracticeGameEntry> => {
  return (
    await tournamentsDefaultClient.playPlatformPracticeGame(
      platformType,
      playPracticeDto,
    )
  ).data;
};
